// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"296":"fff2e39d","530":"9c195e86","585":"38a19dc1"}[chunkId] + ".css";
};